var _excluded = ["data", "disableFunc", "header", "render", "onUnmount", "onMount", "onClose", "width", "submitLabel", "disableEnterKeyOnForm", "disableAutoComplete", "children"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import PropTypes from "prop-types";
import ModalConfirm from "../modals/modal-confirm";
import FormManager from "./form-manager";

var ModalFormBase = function ModalFormBase(_ref) {
  var data = _ref.data,
      disableFunc = _ref.disableFunc,
      header = _ref.header,
      render = _ref.render,
      onUnmount = _ref.onUnmount,
      onMount = _ref.onMount,
      onClose = _ref.onClose,
      width = _ref.width,
      submitLabel = _ref.submitLabel,
      disableEnterKeyOnForm = _ref.disableEnterKeyOnForm,
      disableAutoComplete = _ref.disableAutoComplete,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(FormManager, {
    data: data,
    disableFunc: disableFunc,
    onSubmit: function onSubmit(state, setState) {
      props.handleSubmit(state);
      onUnmount();
      onClose();
    }
  }, function (_ref2) {
    var isDisabled = _ref2.isDisabled,
        state = _ref2.state,
        setState = _ref2.setState,
        errors = _ref2.errors,
        handleSubmit = _ref2.handleSubmit;
    var renderProp = typeof render === "function" ? render : children;
    return /*#__PURE__*/React.createElement(ModalConfirm, _extends({}, props, {
      closeModal: onClose,
      header: header,
      disableSave: isDisabled,
      saveLabel: submitLabel,
      onSubmit: handleSubmit
    }), /*#__PURE__*/React.createElement("div", {
      "data-testid": "modal-confirm",
      className: "et--modal-form"
    }, /*#__PURE__*/React.createElement("form", {
      onSubmit: function onSubmit(e) {
        e.preventDefault();
        handleSubmit(state, setState);
      }
    }, renderProp({
      state: state,
      setState: setState,
      errors: errors
    }))));
  });
};

ModalFormBase.defaultProps = {
  disableFunc: function disableFunc() {
    return false;
  },
  onUnmount: function onUnmount() {},
  onClose: function onClose() {},
  header: null,
  data: {}
};
ModalFormBase.propTypes = {
  /** give it a function that returns a) a boolean - will just disable the submit button
   * b) and object like {isDisabled: true, errors: {email: "Invalid", name: "this is a duplicate"}}
   *  this will disable the submit button and then pass this errors object into your render prop
   * use the errors object to display helpful messages to the user
   **/
  disableFunc: PropTypes.func,

  /** AKA initalState */
  data: PropTypes.object,
  header: PropTypes.string,

  /** params are `({setState, state})` */
  render: PropTypes.func,

  /** params: ({setState, state}) */
  handleSubmit: PropTypes.func,
  submitLabel: PropTypes.string,

  /** use a <form> 's onSubmit handler to catch the enter key */
  disableEnterKeyOnForm: PropTypes.bool,

  /** disable a <form> 's autocomplete feature or don't put a name on the input to disalbe individally */
  disableAutoComplete: PropTypes.bool
};
ModalFormBase.displayName = "ModalFormBase";
export default ModalFormBase;